import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-tertiary)";

function IconOrganizationAvatarPlaceholder({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M18.99 7.672c.2-.023.403-.034.61-.034 2.982 0 5.4 2.442 5.4 5.454 0 3.012-2.418 5.455-5.4 5.455l-.332-.002c-.741-.004-1.488-.009-2.201.184l-2.793.752a5.34 5.34 0 0 1-1.874.338c-2.982 0-5.4-2.442-5.4-5.454a5.46 5.46 0 0 1 3.08-4.927C10.874 7.423 12.822 6 15.1 6c1.528 0 2.908.641 3.89 1.672z"/>
            <path fill={fill} d="M14.1 21.26a.91.91 0 0 1 .687-.733l2.943-.697a.909.909 0 0 1 1.11.758l.615 4.376a.91.91 0 0 1-.9 1.036h-4.179a.91.91 0 0 1-.896-1.06l.62-3.68z"/>
        </svg>
    );
}

export default IconOrganizationAvatarPlaceholder;
